module.exports = __webpack_public_path__ + "static/flexviz-42f63cb0a733b88b18d287ccb1929ffa.png";